import React from "react";
import BottomSheet from "../../../components/ui/BottomSheet";
import SheetHeader from "../../../components/ui/SheetHeader";
import Icon from "../../../components/ui/Icon";
import Button from "../../../components/ui/Button";
import { useIsDesktopViewport } from "../../../hooks/useIsDesktopViewport";
import { IAddress } from "../../../classes/interfaces";
import {
  Body,
  EmptyMessage,
  AddressRow,
  AddressInfo,
  AddressTitle,
  AddressSub,
  RemoveButton,
  EditButton,
  Footer,
} from "./AddressListModal.styles";

interface AddressListModalProps {
  isOpen: boolean;
  onClose: () => void;
  addresses: IAddress[];
  onSelectAddress: (address: IAddress) => void;
  onEditAddress: (address: IAddress) => void;
  onRemoveAddress: (key: string) => void;
  onAddNewAddress: () => void;
}

export default function AddressListModal({
  isOpen,
  onClose,
  addresses,
  onSelectAddress,
  onEditAddress,
  onRemoveAddress,
  onAddNewAddress,
}: AddressListModalProps) {
  const desktop = useIsDesktopViewport();

  return (
    <BottomSheet open={isOpen} onClose={onClose} centered={desktop} maxHeight="80%">
      <SheetHeader
        title="Meus Endereços"
        sub="Clique sobre o endereço para indicar onde será entregue o seu pedido"
        onClose={onClose}
      />
      <Body>
        {addresses.length <= 0 && (
          <EmptyMessage>
            Você ainda não tem nenhum endereço por aqui, clique no botão "Novo Endereço" para
            adicionar um endereço.
          </EmptyMessage>
        )}
        {addresses.map((address) => (
          <AddressRow key={address.key} onClick={() => onSelectAddress(address)}>
            <AddressInfo>
              <AddressTitle>{address.address + ", " + address.number}</AddressTitle>
              <AddressSub>
                {address.district +
                  " - " +
                  address.city +
                  (address.complement !== "" ? " - Complemento: " + address.complement : "") +
                  (address.reference !== "" ? " - Referência: " + address.reference : "")}
              </AddressSub>
            </AddressInfo>
            <EditButton
              type="button"
              aria-label="Editar endereço"
              onClick={(e) => {
                e.stopPropagation();
                onEditAddress(address);
              }}
            >
              <Icon name="pencil" size={16} strokeWidth={2} />
            </EditButton>
            {/* stopPropagation: sem ele o clique em remover também selecionava o
                endereço (onClick da linha) e pedia a taxa — inclusive abrindo a
                edição de bairro junto com a confirmação de remoção. */}
            <RemoveButton
              type="button"
              aria-label="Remover endereço"
              onClick={(e) => {
                e.stopPropagation();
                onRemoveAddress(address.key);
              }}
            >
              <Icon name="trash" size={17} strokeWidth={2} />
            </RemoveButton>
          </AddressRow>
        ))}
      </Body>
      <Footer>
        <Button variant="primary" full onClick={onAddNewAddress}>
          Novo Endereço
        </Button>
      </Footer>
    </BottomSheet>
  );
}
